// Phase 9 — uniform top-of-page chrome used on every authenticated page.
//
// Props
//   title    — required, string. Rendered as the page-level H1.
//   subtitle — optional, string or ReactNode. Muted one-liner under the
//              title.
//   actions  — optional, array of ReactNodes (typically <button/>s) laid
//              out right-aligned. Use this for "New …", "Promote",
//              "Download", etc.
//   testId   — optional, data-testid on the outer wrapper. Defaults to
//              "page-header".
//
// Typography follows the brief exactly: 32px / 600 weight title, 14px /
// 400 muted subtitle, generous top margin.
export default function PageHeader({
    title,
    subtitle = null,
    actions = null,
    testId = "page-header",
    children = null,
}) {
    const actionArray = Array.isArray(actions)
        ? actions.filter(Boolean)
        : actions
          ? [actions]
          : [];
    return (
        <div
            className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 pb-4 border-b border-ux-border-1"
            data-testid={testId}
        >
            <div className="min-w-0">
                <h1
                    className="text-[32px] leading-tight font-semibold text-ux-text-1 tracking-tight truncate"
                    data-testid={`${testId}-title`}
                >
                    {title}
                </h1>
                {subtitle && (
                    <p
                        className="mt-1 text-[14px] font-normal text-ux-text-3 truncate"
                        data-testid={`${testId}-subtitle`}
                    >
                        {subtitle}
                    </p>
                )}
                {children}
            </div>
            {actionArray.length > 0 && (
                <div
                    className="flex flex-wrap items-center gap-2 shrink-0"
                    data-testid={`${testId}-actions`}
                >
                    {actionArray.map((a, i) => (
                        <div key={i}>{a}</div>
                    ))}
                </div>
            )}
        </div>
    );
}
